import { useState } from "react";
import { Bell, Check } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export function SizeAlert({ product }) {
  const { t } = useStore();
  const soldOut = product.sizes.filter((s) => s.stock <= 0);
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  if (!soldOut.length) return null;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/size-alerts", { product_id: product.id, size, email });
      setDone(true);
      toast.success(t("alertSaved"), { description: `EU ${size}` });
    } catch (err) {
      toast.error(errMsg(err));
    } finally { setBusy(false); }
  };
  const openWith = () => { setDone(false); setSize(soldOut[0].size); setOpen(true); };

  return (
    <>
      <button type="button" onClick={openWith} data-testid="size-alert-open-btn"
        className="link-u mt-3 flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider">
        <Bell className="h-3.5 w-3.5" /> {t("alertCta")}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md rounded-none border-ink bg-sun" data-testid="size-alert-dialog">
          <DialogTitle className="font-display text-2xl font-black uppercase">{t("alertTitle")}</DialogTitle>
          <p className="text-sm text-ink/70">{product.name}</p>
          {done ? (
            <div className="flex items-start gap-3 py-4" data-testid="size-alert-success">
              <Check className="mt-0.5 h-5 w-5" />
              <p className="text-sm">{t("alertDone", { size, email })}</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <div>
                <p className="eyebrow mb-3">{t("alertPick")}</p>
                <div className="grid grid-cols-5 gap-1.5">
                  {soldOut.map((s) => (
                    <button type="button" key={s.size} onClick={() => setSize(s.size)} data-testid={`size-alert-size-${s.size}`}
                      className={`border py-2.5 font-mono text-xs transition-colors ${size === s.size ? "border-ink bg-ink text-sun" : "border-ink/20 hover:border-ink"}`}>{s.size}</button>
                  ))}
                </div>
              </div>
              <Input type="email" required placeholder="email@domain.com" value={email} onChange={(e) => setEmail(e.target.value)}
                className="h-12 rounded-none border-ink/20 bg-white" data-testid="size-alert-email-input" />
              <button className="btn-ink w-full" disabled={busy || !size} data-testid="size-alert-submit-btn">{t("alertSubmit")}</button>
              <p className="text-xs text-ink/50">{t("alertNote")}</p>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
